export type CoTGroupKey = 'group-chainOfThought' | 'group-reasoning' | 'group-tool'

/** Stable groupBy for Chain of Thought (reasoning + tools under one Working strip). */
export function omicsCoTGroupBy(part: {type: string}): readonly CoTGroupKey[] | null {
  if (part.type === 'reasoning') return ['group-chainOfThought', 'group-reasoning']
  if (part.type === 'tool-call') return ['group-chainOfThought', 'group-tool']
  return null
}
